import { Navigate, Route, Routes, useLocation } from 'react-router';
import Loading from '../common/lib/Loading';
import PageNotFound from '../common/lib/PageNotFound';
import useInitialized from '../common/lib/useInitialized';
import type { MultiLang } from '../config';
import './assets/style.css';
import CosmoDbDetail from './CosmoDbDetail';
import CosmoDbList from './CosmoDbList';
import type CosmoDbContext from './lib/CosmoDbContext';
import CosmoDbUtils from './lib/CosmoDbUtils';

interface Props {
    lang: MultiLang;
    dirname: string;
}

interface PageProps {
    lang: MultiLang;
    context: CosmoDbContext;
}

const CosmoDbListPage = (props: PageProps) => {
    const { lang, context } = props;
    const { search } = useLocation();
    return <CosmoDbList lang={lang} context={context} params={new URLSearchParams(search)} />;
};

const CosmoDbDetailPage = (props: PageProps) => {
    const { lang, context } = props;
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const idStr = params.get('id') || '';
    const tabStr = params.get('tab') || '1';
    if (!/^\d+/.test(idStr) || !/^\d+/.test(tabStr)) {
        return <PageNotFound lang={lang} />;
    }
    return <CosmoDbDetail lang={lang} context={context} id={parseInt(idStr, 10)} tab={parseInt(tabStr, 10)} />;
};

const CosmoDb = (props: Props) => {
    const { lang, dirname } = props;
    const context = CosmoDbUtils.getContext(dirname);
    const status = useInitialized(context.initialize);
    if (status === null) {
        return <Loading />;
    }
    if (!status) {
        return <PageNotFound lang={lang} />;
    }
    const topUrl = context.getUrl('list.php?id=1');
    return (
        <div className="cosmodb">
            <Routes>
                <Route index element={<Navigate to={topUrl} replace />} />
                <Route path="index.php" element={<Navigate to={topUrl} replace />} />
                <Route path="list.php" element={<CosmoDbListPage lang={lang} context={context} />} />
                <Route path="detail.php" element={<CosmoDbDetailPage lang={lang} context={context} />} />
                <Route path="*" element={<PageNotFound lang={lang} />} />
            </Routes>
        </div>
    );
};

export default CosmoDb;
